import { useId } from "react";
import { cn } from "@/lib/utils";

export function BloomInput({
  label,
  icon: Icon,
  helper,
  error,
  className,
  id,
  ...props
}) {
  const generated = useId();
  const inputId = id || generated;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="mb-2 block text-sm font-bold text-foreground">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <Icon
            size={22}
            weight="bold"
            className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
        )}
        <input
          id={inputId}
          aria-invalid={!!error}
          aria-describedby={helper || error ? `${inputId}-desc` : undefined}
          className={cn(
            "min-h-[56px] w-full rounded-2xl border-2 bg-muted/50 px-4 text-base font-medium text-foreground placeholder:text-muted-foreground/70",
            "transition-all duration-200 focus:bg-card focus:outline-none focus:ring-4 focus:ring-primary/20",
            Icon && "pl-12",
            error ? "border-destructive focus:border-destructive focus:ring-destructive/20" : "border-input focus:border-primary",
            className,
          )}
          {...props}
        />
      </div>
      {(helper || error) && (
        <p
          id={`${inputId}-desc`}
          className={cn("mt-2 text-sm font-semibold", error ? "text-destructive-ink" : "text-muted-foreground")}
        >
          {error || helper}
        </p>
      )}
    </div>
  );
}

export default BloomInput;
